// istanbul made me do this
const noOpHandleFetchSuggestions = () => undefined;
export default noOpHandleFetchSuggestions;
//# sourceMappingURL=noOpHandleFetchSuggestions.js.map